import { render, staticRenderFns } from "./Stage1_Staff_Initial.vue?vue&type=template&id=514b8640&scoped=true&"
import script from "./Stage1_Staff_Initial.vue?vue&type=script&lang=js&"
export * from "./Stage1_Staff_Initial.vue?vue&type=script&lang=js&"
import style0 from "./Stage1_Staff_Initial.vue?vue&type=style&index=0&id=514b8640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b8640",
  null
  
)

export default component.exports